import partnerData from './partner-data';

export default {
  partnerData,
};
